module.exports = __webpack_public_path__ + "img/6_dogbreed.67bd0b0a.jpg";